import React from "react";
import { getAllFavourites, deleteFavourites } from "../api";
import { NavLink } from "react-router-dom";

import "./Favourites.css";

import { toast } from "react-toastify";

class Favourites extends React.Component {
  state = {
    favourites: [],
  };

  async componentDidMount() {
    const response = await getAllFavourites();
    this.setState({
      favourites: response.data,
    });
  }

  handleDeleteFavourite = async (id) => {
    await deleteFavourites(id);
    const newFav = [...this.state.favourites];
    newFav.forEach((fav) => {
      if (fav._id === id) {
        fav.deleted = true;
      }
    });
    this.setState({
      favourites: newFav,
    });
    toast.dark(`Auto Repair Service was removed from your favourites`);
  };

  render() {
    return (
      <main className="box">
        <div className="backMenuBox">
          <NavLink to="/map">
            <img src="/images/back.png" />
          </NavLink>
          <h1>Your Favourites</h1>
        </div>

        <div className="totalFavourites">
          {this.state.favourites.map((favourite, index) => {
            return (
              <div key={index}>
                <section className="favouritesBox">
                  <div className="favouritesTopBox">
                    <img
                      className="favouritesImgBox"
                      src="/images/locationlogo.png"
                    />
                    <h2>{favourite.name}</h2>
                    <div>
                    {favourite.rating ? (
                  <div className="markerInfoRating">
                    <img src="/images/star.png" />
                    {favourite.rating}/5
                  </div>
                ) : (
                  <div className="markerInfoNoRating">
                  <img src="/images/star.png" />
                  <p>no rating</p>
                  </div>
      
                      )}
                    </div>
                  </div>

                  <div className="heartBox">
                    <div className="favouritesAddressBox">
                      <h4>Address</h4>
                      <p>{favourite.icon}</p>
                    </div>
                    <button
                      onClick={() => this.handleDeleteFavourite(favourite._id)}
                    >
                      {favourite.deleted ? (
                        <img src="/images/unfav.png" />
                      ) : (
                        <img src="/images/fav.png" />
                      )}
                    </button>
                  </div>
                </section>
              </div>
            );
          })}
        </div>
      </main>
    );
  }
}

export default Favourites;
